import React, { useEffect, useState } from 'react';
import { ReactComponent as ThumbsDown } from '../icons/thumbs_down.svg';
import { ReactComponent as ThumbsDownSelected } from '../icons/thumbs_down_selected.svg';
import styles from './FeedbackQnA.module.css';
import classNames from 'classnames';
import { logEvent as logAnalyticsEvent } from '../analytics';
import { getTenantName } from '../helpers';

export const feedbackQnAContentType = 'application/providence.feedbackQnA';

export enum FeedbackSelectedStatus {
    None,
    Positive,
    Negative,
}

export const FeedbackQnA: React.FC<{
    initialSelectedFeedback: FeedbackSelectedStatus;
    source: string;
    intent: string;
    correlationId: string;
    setFeedbackStatus?: (status: FeedbackSelectedStatus) => void;
}> = ({
    initialSelectedFeedback,
    source,
    intent,
    correlationId,
    setFeedbackStatus,
}) => {
    const [selectedFeedback, setSelectedFeedback] =
        useState<FeedbackSelectedStatus>(initialSelectedFeedback);

    useEffect(() => {
        logAnalyticsEvent('Feedback Response - Shown', {
            intent: intent,
            kb: source,
            'correlation id': correlationId,
        });
    }, []);

    const onFeedback = (status: FeedbackSelectedStatus) => {
        setSelectedFeedback(status);

        logAnalyticsEvent('Feedback Response - Click', {
            intent: intent,
            kb: source,
            chatbot_tenant: getTenantName(),
            'correlation id': correlationId,
            click_type:
                status == FeedbackSelectedStatus.Positive
                    ? 'thumbs up'
                    : 'thumbs down',
        });

        if (setFeedbackStatus) {
            setFeedbackStatus(status);
        }
    };

    return (
        <div>
            {selectedFeedback === FeedbackSelectedStatus.Positive ? (
                <button
                    aria-label="thumbs-up-button"
                    className={styles.thumbsButton}
                >
                    <ThumbsDownSelected
                        className={classNames(styles.thumbsUp, styles.selected)}
                    />
                </button>
            ) : (
                <button
                    aria-label="thumbs-up-button"
                    className={styles.thumbsButton}
                    onClick={() => onFeedback(FeedbackSelectedStatus.Positive)}
                >
                    <ThumbsDown className={styles.thumbsUp} />
                </button>
            )}
            {selectedFeedback === FeedbackSelectedStatus.Negative ? (
                <button
                    aria-label="thumbs-down-button"
                    className={styles.thumbsButton}
                >
                    <ThumbsDownSelected
                        className={classNames(
                            styles.thumbsDown,
                            styles.selected
                        )}
                    />
                </button>
            ) : (
                <button
                    aria-label="thumbs-down-button"
                    className={styles.thumbsButton}
                    onClick={() => onFeedback(FeedbackSelectedStatus.Negative)}
                >
                    <ThumbsDown className={styles.thumbsDown} />
                </button>
            )}
        </div>
    );
};
